import * as React from 'react';

interface IProps{
    light?: boolean;
    merged?: boolean;
    transparent?: boolean;
    watchOutMerge?: boolean;
    style?: React.CSSProperties;
    className?: string;
    maxWidth?: boolean;
    idk?: string;
}

export default class Container extends React.Component<IProps & React.CSSProperties, any>{

    render(){
        return (
            <div style={this.props.style} className={`container full-width ${this.props.light? 'light': ''} ${this.props.merged? 'merged': ''} ${this.props.watchOutMerge? 'avoid-merge': ''} ${this.props.transparent? 'transparent': ''} ${this.props.className || ''}`}>
                <div className='main-wrapper'>
                    {this.props.children}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/core/ui/container.tsx